import { initializeApp } from "firebase/app";
import { getMessaging, isSupported } from "firebase/messaging";
import { firebaseApiKey, firebaseAppId, firebaseAuthDomain, firebaseMeasurementId, firebaseMessagingSenderId, firebaseProjectId, firebaseStorageBucket } from "./baseUrl";

const firebaseConfig = {
  apiKey: firebaseApiKey,
  authDomain: firebaseAuthDomain,
  projectId: firebaseProjectId,
  storageBucket: firebaseStorageBucket,
  messagingSenderId: firebaseMessagingSenderId,
  appId: firebaseAppId,
  measurementId: firebaseMeasurementId
};

export const app = initializeApp(firebaseConfig);
// export const messaging = getMessaging(app);
// Safe check for messaging support
export const messaging = async () => {
  const supported = await isSupported();
  if (supported) {
    return getMessaging(app);
  } else {
    return null;
  }
};